// src/lib/supabaseClient.ts
import { createClient, SupabaseClient } from '@supabase/supabase-js';

interface Database {
  public: {
    Tables: {
      profiles: {
        Row: { 
          user_id: string;
          username: string;
          faction_id: number;
          cc_balance: number;
          created_at: string;
          is_admin?: boolean;
        }
        Insert: { 
          user_id: string;
          username: string;
          faction_id: number;
          cc_balance?: number;
        }
        Update: { 
          username?: string;
          faction_id?: number;
          cc_balance?: number;
        }
      },
      rapid_response_enemy_words: {
        Row: {
          word_id: number;
          enemy_type: string;
          word_text: string;
          difficulty_level: number;
          word_length: number;
          created_at: string;
        }
        Insert: {
          enemy_type: string;
          word_text: string;
          difficulty_level: number;
          word_length: number;
        }
      },
      rapid_response_sessions: {
        Row: {
          session_id: number;
          user_id: string;
          score: number;
          wpm: number;
          words_typed: number;
          waves_survived: number;
          duration_seconds: number;
          started_at: string;
          ended_at: string;
        }
        Insert: {
          user_id: string;
          score: number;
          wpm: number;
          words_typed: number;
          waves_survived: number;
          duration_seconds: number;
          started_at: string;
          ended_at: string;
        }
      }
    }
  }
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl, 
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'sb-auth-token',
    },
    global: {
      headers: {
        'X-Client-Info': 'rapid-response-game',
      },
    },
  }
);

// ===================================